import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Loader } from 'semantic-ui-react';
import { financialCategoryActions } from '../../actions/financial-category.actions';
import { DynamicTable } from '../../components/DynamicTable/DynamicTable';

class FinancialCategoryScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(financialCategoryActions.getAll()).then(() => {
      this.setState({
        refresh: true,
      });
    });
  }

  render() {
    const { sub_categories, loading } = this.props;
    const { refresh } = this.state;

    if (!sub_categories?.data) {
      return <Loader active={loading} />;
    }

    return (
      <Fragment>
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>Categoria Financeira</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button primary onClick={() => this.props.history.push('/finance/categories/create')}>
              Novo
            </Button>
          </Grid.Column>
        </Grid>
        <Loader active={loading} />
        {!loading && (
          <DynamicTable
            refresh={refresh}
            onClick={(item) => this.props.history.push(`/finance/categories/${item.id}/show`)}
            handlePaginationChange={(page) => {
              const { dispatch } = this.props;
              dispatch(financialCategoryActions.getAll(`page=${page}`));
            }}
            header={['Nome', 'Descrição', 'Grupo']}
            search={{
              name: 'Nome',
              title: 'Descrição',
            }}
            columns={['name', 'description', 'category.name']}
            data={sub_categories.data}
            totalPages={sub_categories.lastPage}
            page={sub_categories.page}
          />
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { financialCategory } = state;
  return {
    sub_categories: financialCategory,
    loading: financialCategory.loading || false,
  };
}

const connectedFinancialCategoryScreen = connect(mapStateToProps)(FinancialCategoryScreen);
export { connectedFinancialCategoryScreen as FinancialCategoryScreen };
